
//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Epk.Dialogs.ts						</Name>
//    <Description> Volání EPK dialogů							</Description>
//    <Author>      Tomáš Hažmuka								</Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2018			</Copyright>
//    <Created>     2018-09-21                                  </Created>
//  </FileHeader>

namespace Gordic.Epk.Dialogs {

	/**
	* Dialog zrušení žádostí v EPK
	*
	* @author  Tomáš Hažmuka
	* @date    14.01.2022
	*
	* @param   parentContent                        The content.
	* @param   ModOtevreni                    mod otevreni dialogu.
	* @return  .
	*/
	export function GEpkZrusitVlastniZadostiDlg(
		parentContent: GContent,
		opt: {
			Rows: Gordic.Wfl.Interface.GPodpisovaKnihaDto[]
		},
		ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
	): JQueryPromise<any> {

		const options = {
			ID: "GEpkVlastniZadostiId#",
			Rows: opt.Rows
		};

		const deferred = $.Deferred();
		const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
		ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

		let isValid = true;

		if (isValid) {
			Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Epk.WebControls.GEpkVlastniZadosti', ModOtevreni, options);
		} else {
			deferred.reject();
		}

		return deferred.promise();

	}

	/**
	* Dialog úvodní stránky v EPK
	*
	* @author  Tomáš Hažmuka
	* @date    15.06.2021
	*
	* @param   parentContent                        The content.
	* @param   ModOtevreni                    mod otevreni dialogu.
	* @return  .
	*/
	export function GEpkDashboardEpkDlg(
		parentContent: GContent,
		opt?: {} | null,	// zatím žádný opt není potřeba
		ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
	): JQueryPromise<any> {

		const options = {
			ID: "EpkDashboard#"
		};

		const deferred = $.Deferred();
		const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
		ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

		let isValid = true;

		if (isValid) {
			Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Epk.WebControls.GEpkDashboard', ModOtevreni, options);
		} else {
			deferred.reject();
		}

		return deferred.promise();

    }

    /**
	* Dialog Seznamů v EPK
	*
	* @author  Tomáš Hažmuka
	* @date    25.07.2018
	*
	* @param   parentContent                        The content.
	* @param   ModOtevreni                    mod otevreni dialogu.
	* @return  .
	*/
    export function SeznamyEpkDlg(
        parentContent: GContent,
        opt: {
            /** ID Seznamu */
            ID?: string,
            /** ID Úlohy */
            taskId?: string,
            /** typ seznamu */
            TypSeznamu: number,
            /** termín epk  */
			EpkTermin?: Epk.WebControls.EpkTerminEnum,
			/** stav žádosti v EPK05 */
			stavZadosti?: Wfl.Interface.GWflczpvEnum,
			/** přehled za fun, su, úřad,... */
			supervisor?: number,
			/** filtr na barvu */
			uzo?: string,
			cardView?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

        const options = {
            ID: opt ? opt.ID : undefined,
            taskId: opt ? opt.taskId : undefined,
            TypSeznamu: opt ? opt.TypSeznamu : undefined,
            epk_termin: opt ? opt.EpkTermin : undefined,
            stavZadosti: opt ? opt.stavZadosti : undefined,
            supervisor: opt ? opt.supervisor : undefined,
			uzo: opt ? opt.uzo : undefined,
			CardView: opt ? opt.cardView : undefined
		};

		//options.CardView = true;

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;

        if (isValid) {
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Epk.WebControls.GEpkGrid', ModOtevreni, options);
        } else {
            deferred.reject();
        }

        return deferred.promise();
    }

	/**
	* Dialog ověření podpisů
	*
	* @author  Tomáš Hažmuka
	* @date    25.07.2018
	*
	* @param   parentContent                        The content.
	* @param   ModOtevreni                    mod otevreni dialogu.
	* @return  .
	*/
	export function OveritPodpisyDlg(
		parentContent: GContent,
		opt: {
			/** identifikátor */
			Ixp: string
		},
		ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
	): JQueryPromise<undefined> {

		const options = {
			ID: "EPKOvereniPodpisu#",
			Ixp: opt ? opt.Ixp : undefined,
		};

		const deferred = $.Deferred();
		const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
		ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

		//const windowParams: GDialogOptions | undefined = undefined;

		let isValid = true;

		if (isValid) {
			Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Epk.WebControls.OveritPodpisy', ModOtevreni, options, {
				title: "jres:32000025 " + opt.Ixp //RC 32000025 : Výsledek ověření jednotlivých podpisů souboru
			});
		} else {
			deferred.reject();
		}

		return deferred.promise();
	}

	/**
	* Dialog ověření podpisů
	*
	* @author  Tomáš Hažmuka
	* @date    25.07.2018
	*
	* @param   parentContent                        The content.
	* @param   ModOtevreni                    mod otevreni dialogu.
	* @return  .
	*/
	export function HistSchvalDokumentDlg(
		parentContent: GContent,
		opt: {
			/** identifikátor */
			Ixp: string
		},
		ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni): JQueryPromise<undefined> {

		const options = {
			ID: "EPKHistorieSchvalovaniDokumentu#",
			Ixp: opt ? opt.Ixp : undefined,
		};

		const deferred = $.Deferred();
		const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
		ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

		let isValid = true;

		//width: 1200,
		//height: 550

		if (isValid) {
			Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Epk.WebControls.HistSchvalDokument', ModOtevreni, options);
		} else {
			deferred.reject();
		}

		return deferred.promise();
	}

	/**
	* Dialog náhledu zobrazený přes celý content
	*
	* @author  Tomáš Hažmuka
	* @date    28.08.2018
	*
	* @param   parentContent						The content.
	* @param   ModOtevreni							mod otevreni dialogu.
	* @return  .
	*/
	export function NahledDlg(
		parentContent: GContent,
		opt: {
			/** identifikátor Ixp */
			Ixp: string,
			/** stavy */
			States: any,
			/** informace o připojeném souboru */
			FileInfo: Gordic.Epk.WebControls.EpkFileInfo
		},
		ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni): JQueryPromise<undefined> {

		const options = {
			ID: "EPKNahled#",
			Ixp: opt ? opt.Ixp : undefined,
			States: opt ? opt.States : undefined,
			FileInfo: opt ? opt.FileInfo : undefined
		};

		const deferred = $.Deferred();
		const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
		ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

		let isValid = true;

		if (isValid) {
			Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Epk.WebControls.NahledZadosti', ModOtevreni, options);
		}
		else {
			deferred.reject();
		}

		return deferred.promise();
	}


	/**
	* Dialog hromadného vyřízení záznamů v EPK
	*
	* @author  Tomáš Hažmuka
	* @date    26.09.2018
	*
	* @param   parentContent					The content.
	* @param   ModOtevreni						mod otevreni dialogu.
	* @return  .
	*/
	export function GEpkMultiSettlementDlg(
		parentContent: GContent,
		opt: {
			/** pole identifikátorů a ser_cisel */
			ixps: { ixp: string, ser_cislo: number }[],
			/** vstupní způsob vyřízení */
			zpus_vyriz: Wfl.Interface.GWflczpvEnum 
		},
		ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni): JQueryPromise<any> {

		const options = {
			ID: "EpkMultiSettlement#",
			ixps: opt ? opt.ixps : undefined,
			zpus_vyriz: opt ? opt.zpus_vyriz : undefined,
			progressState: false
		};

		const deferred = $.Deferred();
		const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
		ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

		let isValid = true;

		if (isValid) {
			Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Epk.WebControls.GEpkMultiSettlement', ModOtevreni, options);
		}
		else {
			deferred.reject();
		}

		return deferred.promise();
	}

	/**
	* Dialog k posouzení
	*
	* @author  Tomáš Hažmuka
	* @date    02.10.2018
	*
	* @param   parentContent					The content.
	* @param   ModOtevreni						mod otevreni dialogu.
	* @return  .
	*/
	export function KPosouzeniDlg(
		parentContent: GContent,
		opt: {
			rows: Gordic.Wfl.Interface.GPodpisovaKnihaDto[]
		},
		ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni): JQueryPromise<boolean> {

		const options = {
			ID: "EPKKPosouzeni#",
			Rows: opt ? opt.rows : undefined
		};

		const deferred = $.Deferred();
		const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
		ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

		let isValid = true;

		if (isValid) {
			Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Epk.WebControls.KPosouzeni', ModOtevreni, options);
		}
		else {
			deferred.reject();
		}

		return deferred.promise();
	}

	/**
	* Dialog žádosti o schválení certifikátu
	*
	* @author  Tomáš Hažmuka
	* @date    10.10.2018
	*
	* @param   parentContent					The content.
	* @param   ModOtevreni						mod otevreni dialogu.
	* @return  .
	*/
	export function ZadostSchvalCertifikatDlg(
		parentContent: GContent,
		opt: {
			///** identifikátor */
			//Ixp: string
		},
		ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni): JQueryPromise<undefined> {

		const options = {
			ID: "EPKZadostSchvalCertifikat#",
			//Ixp: opt ? opt.Ixp : undefined,
		};

		const deferred = $.Deferred();
		const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
		ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

		let isValid = true;

		if (isValid) {
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Epk.WebControls.GEpkRequestForCert', ModOtevreni, options);
		}
		else {
			deferred.reject();
		}

		return deferred.promise();
	}

	/**
	* Dialog detailu žádosti (ISL)
	*
	* @author  Tomáš Hažmuka
	* @date    28.03.2018
	*
	* @param   parentContent						The content.
	* @param   ModOtevreni							mod otevreni dialogu.
	* @return  .
	*/
	export function DetailZadostiDlg(
		parentContent: GContent,
		opt: WebControls.GEpkDetailDlgInputParams,
		ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni): JQueryPromise<{ refresh?: boolean, flash?: GFlashOptions }> {

		const gridRemoteControl = opt && opt.Grid ? new Gordic.Components.GridRC(opt.Grid) : undefined;

		const options = {
			ID: "EPKDetailZadostiIsl#",
			Ixp: opt ? opt.Ixp : undefined,
			supervisor: opt ? opt.supervisor : undefined,
			SerCislo: opt ? opt.SerCislo : undefined,
			ArrowControl: opt && opt.Grid ? true : false 
		};

		var task = 'Gordic.Epk.WebControls.GEpkDetail';

		if (opt.Mobile === true) {
			task = 'Gordic.Epk.WebControls.GEpkDetailMobile';
		}

		const deferred = $.Deferred();
		const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
		ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

		let isValid = true;

		if (isValid) {
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, [task, { gridRemoteControl: gridRemoteControl }], ModOtevreni, options);

		}
		else {
			deferred.reject();
		}

		return deferred.promise();
    }





	/**
	* Dialog hromadného vyřízení záznamů v EPK (NEW)
	*
	* @author  Tomáš Hažmuka
	* @date    26.09.2018
	*
	* @param   parentContent					The content.
	* @param   ModOtevreni						mod otevreni dialogu.
	* @return  .
	*/
    export function HromadneVyrizeniIslDlg(
        parentContent: GContent,
        opt: {
            /** pole identifikátorů a ser_cisel */
            ixps: { ixp: string, ser_cislo: number }[],
            /** 0 - vyřídit
             *  1 - vrátit k přepracování 
             *  2 - k posouzení */
            typVyrizeni: number
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni): JQueryPromise<any> {

        const options = {
            ID: "EPKHromadneVyrizeniIsl#",
            ixps: opt ? opt.ixps : undefined,
            typVyrizeni: opt ? opt.typVyrizeni : undefined,
            progressState: false
        };

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;

        if (isValid) {
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Epk.WebControls.GEpkHromadVyrizeni', ModOtevreni, options);
        }
        else {
            deferred.reject();
        }

        return deferred.promise();
    }

}